var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(node,index){return _c('DepartmentTreeNode',{key:'str' + index,attrs:{"node":node},on:{"onNodeClick":_vm.onNodeClick}},[_vm._v(" "+_vm._s(node)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }